import React from 'react';

/**
 * ZHELTA shield mark — official brand asset.
 *
 * Renders the canonical PNG (yellow flame inside dark shield, white border)
 * served from `/brand/zhelta-shield.png`. The asset has a transparent
 * background so it sits cleanly on both light and dark surfaces.
 *
 * Used by every Header, Footer, partner strip, etc. across all 3 divisions
 * + the homepage. Swapping this file propagates the new logo sitewide.
 */
export default function ZheltaLogo({ size = 36, className = '' }) {
  return (
    <span
      className={`inline-flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
      aria-label="ZHELTA"
    >
      <img
        src="/brand/zhelta-shield.png"
        alt=""
        width={size}
        height={size}
        loading="eager"
        decoding="async"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          display: 'block',
        }}
      />
    </span>
  );
}
